import React, { useEffect, useState } from 'react';
import { Form, Row, Col, Input, Button, Modal, Radio } from 'antd';
import Logo from '../assets/images/logo/logo.webp'
import { FaCopyright, FaPencilAlt, FaWhatsapp } from "react-icons/fa";
import { Link, useNavigate } from 'react-router-dom';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { getOtpConfirmation, getUserloginSignUp, getUserResendOtpWhatsapp } from '../services/auth/authServices';
import { done, loginBack } from '../utils/ImagePath';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { getIPAddress, getIPData } from '../services/flight/flightServices';
import { setModal2Open } from '../redux/hotel/modalSlice';
import { useDispatch, useSelector } from 'react-redux';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';

const Login = () => {
    const { executeRecaptcha } = useGoogleReCaptcha(); 
    const [phone, setPhone] = useState('');
    const [isValid, setIsValid] = useState(false);

    const [oTPShowSection, setOTPShowSection] = useState(null);
    const [valueOtp, setValueOtp] = useState("");
    const [timerRunning, setTimerRunning] = useState(true);
    const [resendTime, setResendTime] = useState(60);
    const [invalidMessage, setInvalidMessage] = useState("")
    const [statusCheck, setStatusCheck] = useState("")
    const [form] = Form.useForm();
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const [locationData, setLocationData] = useState(null);
    const [loading, setLoading] = useState(true);

    const currentYear = new Date().getFullYear();


    // useEffect(() => {
    //     const fetchIPAddress = async () => {
    //         try {
    //             const ip = await getIPAddress();
    //             const data = await getIPData(ip?.ip);
    //             setLocationData(data);
    //             setLoading(false);
    //         } catch (error) {
    //             setLoading(false);
    //         }
    //     };

    //     fetchIPAddress();
    // }, []);


    const handlePhoneChange = (value, isValid, country) => {
        const countryIso2 = country?.iso2 || locationData?.countryCode?.toLowerCase();
        const phoneNumber = parsePhoneNumberFromString(value, countryIso2);

        if (phoneNumber) {
            const isValidNumber = phoneNumber.isValid();
            setPhone(value);
            setIsValid(isValidNumber);
        } else {
            setIsValid(false);
        }
    };

    const handleResend = async () => {
        try {
            const payload = { phone_no: phone };
            const response = await getUserloginSignUp(payload);
            console.log("Resending OTP...");
            setTimerRunning(true);
            setResendTime(60);

        } catch (error) {
            console.log("err", error);
        }
    };


    useEffect(() => {
        let timer;
        if (timerRunning && resendTime > 0) {
            timer = setTimeout(() => {
                setResendTime(prevTime => prevTime - 1);
            }, 1000);
        } else if (resendTime === 0) {
            setTimerRunning(false);
        }
        return () => clearTimeout(timer);
    }, [resendTime, timerRunning]);

    const formattedTime = `${String(Math.floor(resendTime / 60)).padStart(2, '0')}:${String(resendTime % 60).padStart(2, '0')}`.toLowerCase();

    // Call SMS function
    const handleFinishOTPSMS = (recaptchaToken) => {
       const payload = { phone_no: phone, recaptchaToken }; 
        getUserloginSignUp(payload)
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    setOTPShowSection(true);
                    setTimerRunning(true);
                    setResendTime(60);
                }
            })
            .catch((error) => {
                console.log("Error during login/signup:", error);
            });
    };


    const handleFinishOTP = async () => {
        try {
            const authenticateOtp = {
                phone_no: phone,
                otp: valueOtp,
            };
            const response = await getOtpConfirmation(authenticateOtp);
            setStatusCheck(response?.data?.data?.message)
            setInvalidMessage("")
            form.resetFields();
            const tokenId = response?.headers?.authorization;
            setTimeout(() => {
                dispatch(setModal2Open(false));
                setStatusCheck("")
                setInvalidMessage("")
                setValueOtp("");
                localStorage.setItem("user", JSON.stringify(response?.data?.data?.user));
                localStorage.setItem("isProfile", JSON.stringify(response?.data?.data?.isProfile));
                localStorage.setItem("isUserType", JSON.stringify(response?.data?.data?.isUserType));
                localStorage.setItem("profile_pic", JSON.stringify(response?.data?.data?.user.profile_pic));
                localStorage.setItem("tokenId", JSON.stringify(tokenId));
                if (response?.data?.data?.isProfile === false) {
                    form.resetFields();
                    navigate("/create-profile", { state: { id: response?.data, tokenId: tokenId } });
                }
                else {
                    form.resetFields();
                    window.location.reload();
                    dispatch(setModal2Open(false));
                }
            }, 3000);

        } catch (error) {
            if (error?.response?.data?.status === 400) {
                setInvalidMessage(error.response.data.message)
                setTimeout(() => {
                    setInvalidMessage("")
                }, 2000);
            }
        }
    };

    // Call WhatsApp function
    const handleUserResendOtpWhatsapp = async (recaptchaToken) => {
       const payload = { phone_no: phone, recaptchaToken };
        getUserResendOtpWhatsapp(payload)
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    setOTPShowSection(true);
                    setTimerRunning(true);
                    setResendTime(60);
                }
            })
            .catch((error) => {
                console.log("Error during login/signup:", error);
            });
    };

    const onChangeVerify = (value) => {
        // Allow only numeric values
        const numericValue = value.replace(/[^0-9]/g, '');
        setValueOtp(numericValue);
    };

    const handleKeyPress = (e) => {
        // Prevent any key that is not a number
        if (!/[0-9]/.test(e.key)) {
            e.preventDefault();
        }
    };

    const optionsWithDisabled = [
        // {
        //     label: 'SMS',
        //     value: 'SMS',
        // },
        {
            label: 'WhatsApp',
            value: 'WhatsApp',
        }
    ];
    const [value4, setValue4] = useState('WhatsApp');

    const onChange4 = ({ target: { value } }) => {
        setValue4(value);
    };

     const handleSendOtp = async () => {
        if (!executeRecaptcha) return;
        const token = await executeRecaptcha('send_otp');
        if (value4 === 'SMS') {
            handleFinishOTPSMS(token); // token pass
        } else if (value4 === 'WhatsApp') {
            handleUserResendOtpWhatsapp(token);  // token pass
        }
    };

    const modal2Open = useSelector((state) => state.modal.modal2Open);

    return (
        <>
            <Modal
                title=""
                centered
                open={modal2Open}
                width={statusCheck ? 300 : 660}
                onOk={() => { dispatch(setModal2Open(false)), setOTPShowSection(false), setPhone('') }}
                onCancel={() => { dispatch(setModal2Open(false)), setOTPShowSection(false), setPhone('') }}
                className='login-popup'
                footer={false}
            >
                <section className=''>
                    {statusCheck ?
                        <div className="text-center">
                            <img loading="lazy" src={done} alt='' style={{ width: "150px" }} />
                            <h2 className='pb-5'>{statusCheck}</h2>
                        </div> :


                        <Row gutter={16}>
                            <Col md={12} xs={24} className='p-0 px-md-2 w-100'>
                                <div className='auth-cntr'>
                                    <img loading="lazy" src={Logo} alt='#' className='img-fluid mt-2 login-logo' width={160} />
                                    <div className='d-md-flex align-items-center h-100'>
                                        {!oTPShowSection ?
                                            <div className='form-box my-5 my-md-0 w-100'>
                                                <h1 className='mb-2'>Login/Signup </h1>
                                                <div className='form-group'>
                                                    <label>Mobile Number</label>
                                                    <PhoneInput
                                                        defaultCountry={locationData?.countryCode?.toLowerCase() || 'in'}
                                                        forceDialCode={true}
                                                        value={phone}
                                                        className="w-100 custom-phone-input"
                                                        placeholder="Enter Mobile Number"
                                                        disableDialCodeAndPrefix={true}
                                                        showDisabledDialCodeAndPrefix={true}
                                                        onChange={handlePhoneChange}
                                                        disableFormatting={true}
                                                    />
                                                    {!isValid && phone && (
                                                        <p style={{ color: 'red', fontSize: '12px' }}>
                                                            Please enter a valid phone number
                                                        </p>
                                                    )}
                                                </div>
                                                <div className='d-flex justify-content-between py-2'>
                                                    <span> Send OTP Via </span>
                                                    <Radio.Group
                                                        options={optionsWithDisabled}
                                                        onChange={onChange4}
                                                        value={value4}
                                                        buttonStyle="solid"
                                                        className="radio-group-style"
                                                    />
                                                    {/* {invalidMessage && <div className="error-message">{invalidMessage}</div>} */}
                                                </div>
                                                <div className=''>
                                                    <Button disabled={!isValid} onClick={handleSendOtp} className='btn btn-primary mt-2 w-100' aria-label="Send OTP">
                                                        Send OTP
                                                        {/* Via {value4} */}
                                                    </Button>
                                                </div>

                                            </div>
                                            :
                                            <Form
                                                form={form}
                                                onFinish={handleFinishOTP}
                                            >
                                                <Form.Item
                                                    className='form-group mb-3'
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please enter the OTP',
                                                        },
                                                        {
                                                            len: 4,
                                                            message: 'OTP must be exactly 4 digits',
                                                        },
                                                    ]}
                                                >
                                                    <label className='d-block mb-1'>
                                                        Enter 6 digit OTP sent to {phone}{' '}
                                                        <Link onClick={() => setOTPShowSection(false)}>
                                                            <FaPencilAlt />
                                                        </Link>
                                                    </label>
                                                    <div className='otp-mobile'>
                                                        <div className={invalidMessage && "error-otp "}>
                                                            <Input.OTP
                                                                inputType="numeric"
                                                                value={valueOtp}
                                                                onChange={onChangeVerify}
                                                                className='error-otp w-100'
                                                                onKeyPress={handleKeyPress}
                                                            />
                                                        </div>
                                                    </div>
                                                </Form.Item>
                                                <span style={{ color: "red" }}> {invalidMessage}</span>

                                                <div className=''>
                                                    {timerRunning ? (
                                                        <p> Time Remaining : {formattedTime} </p>
                                                    ) : (<p>Didn't recieve code ?</p>)}


                                                    <div className='d-flex justify-content-between align-items-center my-3'>
                                                        <p>Resend :  </p>
                                                        <div className='whatsApp mx-2'>
                                                           <Button className='d-flex align-items-center btn btn-primary' onClick={async () => {
                                                                const token = await executeRecaptcha('resend_otp');
                                                                handleUserResendOtpWhatsapp(token);
                                                            }} disabled={timerRunning} aria-label="Whatsapp"><FaWhatsapp twoToneColor="#52c41a" />WhatsApp</Button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <Form.Item>
                                                    <div className='text-end'>
                                                        <Button
                                                            className='btn btn-primary w-100'
                                                            htmlType="submit"
                                                            aria-label="continue"
                                                        >
                                                            Continue
                                                        </Button>
                                                    </div>
                                                </Form.Item>
                                            </Form>
                                        }
                                    </div>
                                    <div className='copyright d-block text-center'>
                                        <small className='d-md-flex align-items-center mb-3'><FaCopyright className='mx-1' /> {currentYear}  <Link to='' className='text-primary mx-1'>SuperbWorldTrip.</Link> All right resererved.</small>
                                    </div>
                                </div>
                            </Col>

                            <Col md={12} className='d-none d-md-block'>
                                <img loading="lazy" src={loginBack} alt='#' className='img-fluid border-start d-flex' />
                            </Col>
                        </Row>}
                </section>
            </Modal>
        </>
    );
};

// export default Login;
const LoginWithProvider = () => (
    <GoogleReCaptchaProvider reCaptchaKey={import.meta.env.VITE_APP_RECAPTCHA_SITE_KEY}>
        <Login />
    </GoogleReCaptchaProvider>
);

export default LoginWithProvider;